import React from "react";
import DatePicker from "react-datepicker";
import FieldInfoPopover from "./FieldInfoPopover";

function toTimeValue(value) {
  const match = String(value || "").match(/^(\d{2}):(\d{2})$/);
  if (!match) {
    return null;
  }

  const date = new Date();
  date.setHours(Number(match[1]), Number(match[2]), 0, 0);
  return date;
}

function fromTimeValue(value) {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
    return "";
  }

  const hours = String(value.getHours()).padStart(2, "0");
  const minutes = String(value.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}

export default function TimeField({
  field,
  required,
  error,
  onChange,
  placeholder,
}) {
  return (
    <div className="col-md-6 mb-md-4">
      <div className={`form-group form-date ${error ? "is-invalid" : ""}`}>
        <label htmlFor={field.id}>
          {required ? <span>*</span> : null}
          {field.title}
        </label>
        <div className={field.labelInfoPopover ? "formHelper" : undefined}>
          <div className="validation-cover">
            <DatePicker
              id={field.id}
              selected={toTimeValue(field.value)}
              onChange={(value) => onChange(field.id, fromTimeValue(value))}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="HH:mm"
              placeholderText={placeholder}
              className="form-control"
              autoComplete="off"
              showPopperArrow={false}
              showIcon
              calendarIconClassName="technical-support-datepicker__icon time"
              icon={
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock" viewBox="0 0 16 16">
                  <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z"/>
                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0"/>
                </svg>
              }
            />
          </div>
          <FieldInfoPopover html={field.labelInfoPopover} />
        </div>
        {field.description ? <div className="mt-2">{field.description}</div> : null}
      </div>
    </div>
  );
}
